export default "/fonts/BestScottishTours.woff2?d4a246d31eed4a571c740f196f6420e9";